import { toError } from '@hprofits/utils';
import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

/**
 * Normalize a reactive error source to `ComputedRef<Error | null>` for the
 * `DataSource` / `DataDispatcher` query contract (`error: Ref<Error | null>`).
 *
 * - `null`/`undefined` → `null` (no error).
 * - `Error` → passthrough.
 * - anything else → wrapped via `@hprofits/utils` `toError` (never dropped), so
 *   a non-`Error` rejection still surfaces as a load failure.
 *
 * Replaces the per-provider `computed(() => e instanceof Error ? e : null)`
 * boilerplate that silently swallowed non-`Error` failures.
 */
export const toErrorRef = (source: MaybeRefOrGetter<unknown>): ComputedRef<Error | null> =>
  computed(() => {
    const e = toValue(source);
    return e == null ? null : toError(e);
  });
